import { Category } from '../components/categories/Category';
import { LockedCategory } from '../components/categories/LockedCategory';
import { jsx as _jsx } from "react/jsx-runtime";
export const CategoryContainer = ({
  category
}) => {
  const {
    templates,
    labelKey,
    accessProperties,
    id
  } = category;
  if (templates.length === 0) {
    return null;
  }
  if (!(accessProperties !== null && accessProperties !== void 0 && accessProperties.accessAllowed)) {
    return /*#__PURE__*/_jsx(LockedCategory, {
      id: id,
      labelKey: labelKey
    });
  }
  return /*#__PURE__*/_jsx(Category, {
    id: id,
    labelKey: labelKey,
    templates: templates
  });
};